import { render, staticRenderFns } from "./properties-block-world-map.vue?vue&type=template&id=70f9c4ee&scoped=true"
import script from "./properties-block-world-map.vue?vue&type=script&lang=js"
export * from "./properties-block-world-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9c4ee",
  null
  
)

export default component.exports